import View from './view';
import {Props} from './model';
import {useSelector} from 'react-redux';
import {profileApplicationsDictionariesSelector} from '../../../../redux/selectors/profile';

export const ApplicationsFilter = (props: Props) => {
  const dictionaries = useSelector(profileApplicationsDictionariesSelector());
  return View({
    ...props,
    ...dictionaries,
  });
};
